/* Use this file to add custom js to the theme for custom sections. */

var desktopNav = (() => {
	var hideSubmenu = (menu) => {
		if (!menu) return;
		if (menu.querySelector('[data-link]').getAttribute('has-submenu') == 'true') {
			menu.querySelector('[js-desktop-nav-submenu]').classList.remove('active');
		}
	}
	var showSubmenu = (menu) => {
		if (!menu) return;
		const container = menu.closest('[js-desktop-nav-container]');
		Array.from(container.querySelectorAll('[js-desktop-nav-menu]')).forEach((element) => {
			hideSubmenu(element);
		});
		if (menu.querySelector('[data-link]').getAttribute('has-submenu') == 'true') {
			menu.querySelector('[js-desktop-nav-submenu]').classList.add('active');
		}
	}

	var initialize = () => {
		document.querySelectorAll('[js-desktop-nav-menu]').forEach((element) => {
			element.addEventListener('mouseover', () => {
				showSubmenu(element);
			});
			element.addEventListener('click', () => {
				showSubmenu(element);
			});
		});
		document.querySelectorAll('[js-desktop-nav-container]').forEach((element) => {
			element.addEventListener('mouseout', () => {
				document.querySelectorAll('[js-desktop-nav-menu]').forEach((element) => {
					hideSubmenu(element);
				});
			});
		});
	}
	
	return {
		init: initialize
	}
})();

var scrollApp = (() => {
	var moveScroll = (container, isNext=true) => {
		let currentIndex = parseInt(container.getAttribute('js-current-scroll-index'));
		var style = window.getComputedStyle(container.closest('div'));
		var paddingLeft = parseInt(style.getPropertyValue('padding-left'));
		if (isNext) {
			container.querySelector('[js-scroll-prev]').classList.remove('hide');
			currentIndex++;
			container.setAttribute('js-current-scroll-index', currentIndex);
			var scrollLeft = container.querySelector('[js-scroll-element]:nth-of-type('+currentIndex+')').offsetLeft - paddingLeft;  // paddingLeft is padding of section
			
			if (scrollLeft >= container.scrollWidth - container.offsetWidth) {
				container.querySelector('[js-scroll-next]').classList.add('hide');
			}
		} else if (!isNext) {
			container.querySelector('[js-scroll-next]').classList.remove('hide');
			currentIndex--;
			container.setAttribute('js-current-scroll-index', currentIndex);
			var scrollLeft = container.querySelector('[js-scroll-element]:nth-of-type('+currentIndex+')').offsetLeft - paddingLeft;  // paddingLeft is padding of section
			if (scrollLeft == 0) {
				container.querySelector('[js-scroll-prev]').classList.add('hide');
			}
		}
		container.scrollTo(scrollLeft, 0);
	}

	var initialize = () => {
		document.querySelectorAll('[js-scroll-next]').forEach((element) => {
			const container = element.closest('[js-scroll-container]');
			if (container.scrollWidth == container.offsetWidth + container.scrollLeft) {
				element.classList.add('hide');
			}
			element.addEventListener('click', () => {
				moveScroll(container);
			})
		});
		document.querySelectorAll('[js-scroll-prev]').forEach((element) => {
			const container = element.closest('[js-scroll-container]');
			if (container.scrollLeft == 0) {
				element.classList.add('hide');
			}
			element.addEventListener('click', () => {
				moveScroll(container, false);
			})
		});

		var touchPoints = [];
		document.querySelectorAll('[js-scroll-container]').forEach((element, index) => {
			touchPoints.push(0);
			if (element.getAttribute('js-scroll-swipe') != null) {
				element.addEventListener('touchstart', () => {
					touchPoints[index] = element.scrollLeft;
				});
				element.addEventListener('touchend', () => {
					const delta = element.scrollLeft - touchPoints[index];
					// const scrollUnit = element.querySelector('[js-scroll-element]').offsetWidth;
					const scrollUnit = 0;
					if (delta >= (-1) * scrollUnit / 2 && delta <= scrollUnit / 2) {
						element.scrollTo(touchPoints[index], 0);
					} else if (delta > scrollUnit / 2) {
						moveScroll(element);
					} else if (delta < (-1) * scrollUnit / 2) {
						moveScroll(element, false);
					}
				});
				element.addEventListener('touchcancel', () => {
					const delta = element.scrollLeft - touchPoints[index];
					const scrollUnit = element.querySelector('[js-scroll-element]').offsetWidth;
					if (delta >= (-1) * scrollUnit / 2 && delta <= scrollUnit / 2) {
						element.scrollTo(touchPoints[index], 0);
					} else if (delta > scrollUnit / 2) {
						moveScroll(element);
					} else if (delta < (-1) * scrollUnit / 2) {
						moveScroll(element, false);
					}
				});
			}
		});
		document.querySelectorAll('[js-scoll-init-center]').forEach((element) => {
			element.scrollTo((element.scrollWidth - element.offsetWidth) / 2, 0);
		});
	}
	return {
		init: initialize
	}
})();


var accordionApp = (() => {
	var closeAccordion = (accordion) => {
		accordion.classList.remove('open');
		accordion.querySelector('[js-accordion-content]').style.maxHeight = '0';
	}

	var openAccordion = (container, accordion) => {
		container.querySelectorAll('[js-accordion-element]').forEach((element) => {
			closeAccordion(element);
		});
		accordion.classList.add('open');
		accordion.querySelector('[js-accordion-content]').style.maxHeight = accordion.querySelector('[js-accordion-content]').scrollHeight + 'px';
	}

	var initialize = () => {
		document.querySelectorAll('[js-accordion-heading]').forEach((element) => {
			const container = element.closest('[js-accordion-container]');
			element.addEventListener('click', () => {
				const accordion = element.closest('[js-accordion-element]');
				if (accordion.classList.contains('open') == true) {
					closeAccordion(accordion);
				} else {
					openAccordion(container, accordion);
				}
			})
		});
	}

	return {
		init: initialize
	}
})();


// This is one for product media slider
var productMediaSlide = (() => {
	var moveSlide = (container, flag) => {
		const currentSlide = container.querySelector('.product__media-item:not(.hidden)');
		let nextSlide = null;
		if (flag == false) {
			nextSlide = currentSlide.previousElementSibling;
		} else if (flag == true) {
			nextSlide = currentSlide.nextElementSibling;
		}
		if (nextSlide && nextSlide.classList.contains('product__media-item')) {
			currentSlide.classList.add('hidden');
			nextSlide.classList.remove('hidden');
			if (flag == false) {
				container.querySelector('[js-product-media-next]').classList.remove('hide');
			} else {
				container.querySelector('[js-product-media-prev]').classList.remove('hide');
			}
			if (nextSlide.previousElementSibling == null || nextSlide.previousElementSibling.classList.contains('product__media-item') == false) {
				container.querySelector('[js-product-media-prev]').classList.add('hide');
			}
			if (nextSlide.nextElementSibling == null || nextSlide.nextElementSibling.classList.contains('product__media-item') == false) {
				container.querySelector('[js-product-media-next]').classList.add('hide');
			}
		}

		// Fallback ohne :has() (Nov. 2026, Claude): alte Browser werfen sonst einen Fehler.
		const activeThumbLink = container.querySelector('.product-thumbnails__item-link.active');
		const currentThumbnail = activeThumbLink ? activeThumbLink.closest('.product-thumbnails__item') : null;
		if (!currentThumbnail) return;
		let nextThumbnail = null;
		if (flag == false) {
			nextThumbnail = currentThumbnail.previousElementSibling;
		} else if (flag == true) {
			nextThumbnail = currentThumbnail.nextElementSibling;
		}
		if (nextThumbnail && nextThumbnail.classList.contains('product-thumbnails__item')) {
			currentThumbnail.querySelector('.product-thumbnails__item-link').classList.remove('active');
			nextThumbnail.querySelector('.product-thumbnails__item-link').classList.add('active');
		}
	}

	var showVideoContainer = (id) => {
		if (document.querySelector('.product__video-container[js-video-id="'+id+'"]') == null) {
			console.log(`can't find the element : .product__video-container[js-video-id="`+id+`"]`);
			return;
		}
		document.querySelector('.product__video-container[js-video-id="'+id+'"]').classList.add('active');
		document.querySelector('.product__video-container[js-video-id="'+id+'"] video').play();
		document.querySelector('body').style.overflow = 'hidden';
	}

	var closeVideoContainer = (container) => {
		if (container.querySelector('video') == null) {
			console.log(`can't find the video element`);
			return;
		}
		const video = container.querySelector('video');
		video.pause();
		video.currentTime = 0;
		console.log(video);
		container.classList.remove('active');
		document.querySelector('body').style.overflow = 'auto';
	}

	var initialize = () => {
		Array.from(document.querySelectorAll('[js-product-media-prev]')).forEach((element) => {
			const container = element.closest('.product__media-container');
			element.addEventListener('click', () => {
				moveSlide(container, false);
			});
		});
		Array.from(document.querySelectorAll('[js-product-media-next]')).forEach((element) => {
			const container = element.closest('.product__media-container');
			element.addEventListener('click', () => {
				moveSlide(container, true);
			});
		});
		Array.from(document.querySelectorAll('.product-thumbnails__item')).forEach((element) => {
			const container = element.closest('.product__media-container');
			element.addEventListener('click', () => {
				if (element.previousElementSibling == null) {
					container.querySelector('[js-product-media-prev]').classList.add('hide');
				} else {
					container.querySelector('[js-product-media-prev]').classList.remove('hide');
				}
				if (element.nextElementSibling == null) {
					container.querySelector('[js-product-media-next]').classList.add('hide');
				} else {
					container.querySelector('[js-product-media-next]').classList.remove('hide');
				}
			});
		});
		Array.from(document.querySelectorAll('[js-product-video-id]')).forEach((element) => {
			element.addEventListener('click', () => {
				showVideoContainer(element.closest('[js-product-video-id]').getAttribute('js-product-video-id'));
			});
		});
		Array.from(document.querySelectorAll('[js-product-video-close-btn]')).forEach((element) => {
			element.addEventListener('click', () => {
				const container = element.closest('.product__video-container');
				closeVideoContainer(container);
			});
		});
	}

	return {
		init: initialize
	}
})();


var app = (() => {
	var removeSpacesOnReview = () => {
		setTimeout(() => {
			document.querySelectorAll('.ruk-rating-snippet-count').forEach((element) => {
				element.innerHTML = element.innerHTML.replace(' ', '')
			});

			document.querySelectorAll('.product__review-price reviewsio-product-ratings>.ruk_rating_snippet').forEach((element) => {
				if (element.innerHTML == '') {
					element.closest('.product__review-price').style.justifyContent = 'center';
					element.closest('.product__review-price').style.gap = '0';
				}
			});
		}, 500);
	}
	// This function is one for collection link list container
	var initCollectionLinksContainer = () => {
		const linksContainer = document.querySelector('.section--custom-collection-image-title--container .link-list');
		if (linksContainer) {
			const activeElement = linksContainer.querySelector('a.active');
			if (activeElement) {
				linksContainer.scrollTo(activeElement.offsetLeft - (linksContainer.closest('.image-container').offsetWidth - activeElement.offsetWidth) / 2, 0);
			}
		}
	}

	// This function is one for background grid
	var initEntireBgContainer = () => {
		const entireBgContainer = document.querySelector('[js-entire-bg]');
		if (entireBgContainer) {
			entireBgContainer.style.height = document.querySelector('main').scrollHeight + 'px';
		}
	}

	// This function is one for benefit section on PDP
	var initBenefitContainer = () => {
		var closeCard = (element) => {
			if (!element) return;
			element.classList.remove('active');
			element.querySelector('.text-container').style.maxHeight = 0 + 'px';
		}
		var openCard = (element) => {
			if (!element) return;
			element.classList.add('active');
			element.querySelector('.text-container').style.maxHeight = element.querySelector('.text-container').scrollHeight + 'px';
		}
		document.querySelectorAll('.main[js-benefit]').forEach((element) => {
			openCard(element);
		});
		document.querySelectorAll('[js-benefit]').forEach((element) => {
			element.addEventListener('mouseover', () => {
				if (!element.classList.contains('main')) {
					closeCard(element.closest('[js-benefit-set]').querySelector('.main[js-benefit]'));
				}
				openCard(element);
			});
			element.addEventListener('mouseout', () => {
				if (!element.classList.contains('main')) {
					closeCard(element);
					openCard(element.closest('[js-benefit-set]').querySelector('.main[js-benefit]'));
				}
			});
		});
		var initMobile = (container) => {
			if (!container) return;
			const maxScrollWidth = container.scrollWidth - container.clientWidth;
			const count = container.querySelectorAll('[js-benefit]').length;
			container.querySelectorAll('[js-benefit]').forEach((element) => {
				closeCard(element);
			});
			switch (container.scrollLeft) {
				case 0:
					openCard(container.querySelector('[js-benefit]:first-of-type'));
					break;
				case maxScrollWidth:
					openCard(container.querySelector('[js-benefit]:last-of-type'));
					break;
				default:
					if (count == 3) {
						openCard(container.querySelector('[js-benefit]:nth-of-type(2)'));
					} else if (count == 4) {
						if (container.scrollLeft <= maxScrollWidth / 2) {
							openCard(container.querySelector('[js-benefit]:nth-of-type(2)'));
						} else {
							openCard(container.querySelector('[js-benefit]:nth-of-type(3)'));
						}
					}
					break;
			}
		}
		document.querySelectorAll('[js-benefit-set]').forEach((container) => {
			if (window.innerWidth < 960) {
				initMobile(container);
			}
			container.addEventListener('scroll', () => {
				initMobile(container);
			});
		});
	}

	var mainResizeObserver = new ResizeObserver(() => {
		initEntireBgContainer();
	});

	var initialize = () => {
		removeSpacesOnReview();
		initEntireBgContainer();
		initCollectionLinksContainer();
		initBenefitContainer();
		desktopNav.init();
		scrollApp.init();
		accordionApp.init();
		mainResizeObserver.observe(document.querySelector('main'));
		productMediaSlide.init();
	}
	return {
		init: initialize
	}
})();

document.addEventListener('DOMContentLoaded', () => {
  	app.init();
});

const elementIsVisibleInViewport = (el, partiallyVisible = true) => {
	const { top, left, bottom, right } = el.getBoundingClientRect();
	const { innerHeight, innerWidth } = window;
	return partiallyVisible
	? ((top > 0 && top < innerHeight) ||
	(bottom > 0 && bottom < innerHeight) || (top <= 0 && bottom >= innerHeight)) &&
	((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
	: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

var lastScrollTop = 0;

document.addEventListener("scroll", function(){
	var st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > lastScrollTop) {
	} else if (st < lastScrollTop) {
	}
	
	Array.from(document.querySelectorAll('.floating-scroll')).forEach((floatingElement) => {
			if (elementIsVisibleInViewport(floatingElement)) {
					let top = 0;
					const { height } = floatingElement.getBoundingClientRect();
					if (floatingElement.getAttribute('js-offset') != null) {
							top = parseFloat(floatingElement.getAttribute('js-offset'));
					}
					let temp = 0;
					if (lastScrollTop != 0) {
							temp = st - lastScrollTop;
					}
					let offset = top + temp/2000.0*height;
					floatingElement.style.transform = 'translateY(' + offset + 'px)';
					floatingElement.setAttribute('js-offset', offset);
			} else {
					const { top, height } = floatingElement.getBoundingClientRect();
					let offset = ((top >= 0) ? (-1) : 1) * (window.innerHeight / 2 + height / 2) / 2000 * height;
					floatingElement.style.transform = 'translateY(' + offset + 'px)';
					floatingElement.setAttribute('js-offset', offset);
			}
	});

	lastScrollTop = st <= 0 ? 0 : st;
}, false);